<template>
  <v-table
      :count="count"
      :list="list"
      :query-list="queryList"
      :is-loading="isLoading"
      :push-list="RouteConfig.youZanSignDateDeletedList.push"
      :is-show-search-input="true"
      search-placeholder="输入标题或副标题关键词进行搜索"
  >
    <v-column-time value="删除时间" field="is_del"/>
    <el-table-column label="ID" prop="id" width="100px"/>

    <v-column-avatar label="删除者"/>
    <el-table-column label="标题关键词" prop="title" width="210px"/>
    <el-table-column label="副标题关键词" prop="title_sub" width="210px"/>
    <v-column-time field="sign_date" time-format="timeToYmd" value="日期"/>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.youZanSignDateEdit.to(row.id)"/>

        <v-list-button
            name="恢复"
            icon="restore"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确认要恢复次日期吗？"
            :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`you-zan-sign-date-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>删除者</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>标题关键词</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>副标题关键词</span>
              <span>{{ v.title_sub }}</span>
            </div>
            <div class="list-item-detail">
              <span>日期</span>
              <span>{{ v.sign_date | timeToYmd }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.youZanSignDateEdit.to(v.id)"/>
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要恢复次日期吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/you-zan-sign-date';

export default {
  name: RouteConfig.youZanSignDateDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (!id) return this.$message.warning('缺少日期 ID，无法恢复该签到日期！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id, { update_time });
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
